import React from 'react';
import { motion } from 'motion/react';
import { Scale, AlertCircle, CheckCircle, Info } from 'lucide-react';
import Seo from '../components/Seo';
import { PAGE_METADATA, getTermsStructuredData } from '../seo/pageMetadata';

const TermsOfService = () => {
  return (
    <>
      <Seo {...PAGE_METADATA.terms} structuredData={getTermsStructuredData()} />
      <div className="pt-32 pb-24">
      <section className="px-6 max-w-4xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }}
          className="mb-16 text-center"
        >
          <div className="inline-flex items-center gap-2 bg-amber-50 border border-amber-100 px-4 py-2 rounded-full mb-6">
            <Scale className="w-4 h-4 text-amber-600" />
            <span className="text-amber-600 text-[10px] font-black uppercase tracking-[0.2em]">Legal Agreement</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-display font-black text-royal-dark tracking-tighter mb-6">
            Terms of <span className="text-royal-purple">Service</span>
          </h1>
          <p className="text-lg text-slate-500 font-medium">
            Last Updated: April 2026
          </p>
        </motion.div>

        <div className="prose prose-slate max-w-none space-y-12">
          <section>
            <h2 className="text-3xl font-display font-black text-royal-dark mb-6 flex items-center gap-3">
              <Info className="w-8 h-8 text-royal-purple" />
              1. Acceptance of Terms
            </h2>
            <p className="text-slate-600 leading-relaxed text-lg font-medium">
              By accessing and using the Delight Business Empowerment website, you agree to comply with and be bound by these Terms of Service. If you do not agree to these terms, please do not use our website.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-display font-black text-royal-dark mb-6 flex items-center gap-3">
              <CheckCircle className="w-8 h-8 text-royal-purple" />
              2. Use of the Website
            </h2>
            <p className="text-slate-600 leading-relaxed text-lg font-medium">
              The content on this website is for your general information and use only. It is subject to change without notice. You agree to use the website only for lawful purposes and in a way that does not infringe the rights of others.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-display font-black text-royal-dark mb-6 flex items-center gap-3">
              <AlertCircle className="w-8 h-8 text-royal-purple" />
              3. Program Applications
            </h2>
            <p className="text-slate-600 leading-relaxed text-lg font-medium">
              Applying for our empowerment programs does not guarantee selection. All applications are reviewed based on our internal criteria, and decisions made by the Delight Business Empowerment team are final.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-display font-black text-royal-dark mb-6 flex items-center gap-3">
              <Scale className="w-8 h-8 text-royal-purple" />
              4. Intellectual Property
            </h2>
            <p className="text-slate-600 leading-relaxed text-lg font-medium">
              This website contains material which is owned by or licensed to us. This material includes, but is not limited to, the design, layout, look, appearance, and graphics. Reproduction is prohibited other than in accordance with the copyright notice.
            </p>
          </section>

          <section className="bg-slate-50 p-10 rounded-[3rem] border border-slate-100">
            <h2 className="text-2xl font-display font-black text-royal-dark mb-4">Governing Law</h2>
            <p className="text-slate-600 font-medium leading-relaxed">
              Your use of this website and any dispute arising out of such use of the website is subject to the laws of the Federal Republic of Nigeria.
            </p>
          </section>
        </div>
      </section>
      </div>
    </>
  );
};

export default TermsOfService;
